import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-brand-cream-light" data-id="element-72">
      <Navigation data-id="element-73" />
      <main className="flex-grow" data-id="element-74">{children}</main>
      <Footer data-id="element-75" />
    </div>;
}